import axios from '../../../axios'



// 获取列表
export const list = (data) => {
  return axios({
    url: '/workorder/auditLog/list',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/biz/workorder/woAuditLog.js